import React from 'react';
import GoogleLoginButton from '../components/GoogleLoginButton';

const primary = '#8d3939ff';

type ReloginPopupProps = {
    isOpen: boolean;
    message?: string;
    onClose: () => void;
    onSuccess?: (credentialResponse: any) => void;
    onFailure?: (error: any) => void;
};

const ReloginPopup: React.FC<ReloginPopupProps> = ({ isOpen, message, onClose, onSuccess, onFailure }) => {
    if (!isOpen) return null;

    const handleSuccess = (resp: any) => {
        if (onSuccess) onSuccess(resp);
        else window.location.reload();
    };

    const handleFailure = (err: any) => {
        if (onFailure) onFailure(err);
        else console.error('Relogin failed', err);
    };

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100
        }} role="dialog" aria-modal="true">
            <div style={{
                background: '#f9f9f9', width: 560, maxWidth: '96%', borderRadius: 12, display: 'flex', flexDirection: 'column',
                boxShadow: '0 14px 40px rgba(13,21,28,0.24)', overflow: 'hidden', fontFamily: 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial'
            }}>
                <div style={{ padding: 20, borderBottom: '1px solid #f3f3f3' }}>
                    <div style={{ fontSize: 18, fontWeight: 600, color: '#222' }}>Session expired</div>
                    <div style={{ marginTop: 8, color: '#555', fontSize: 14 }}>{message || 'Your session has expired. Please sign in again to continue. If there is a problem in the login, try to create a logout and login again.'}</div>
                </div>

                <div style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 12, background: '#fff' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <GoogleLoginButton onSuccess={handleSuccess} onFailure={handleFailure} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button onClick={onClose} style={{ background: 'transparent', color: '#666', border: '1px solid #e9e9e9', padding: '8px 12px', borderRadius: 8, cursor: 'pointer' }}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReloginPopup;
